import React, { createContext } from "react";
import { useWindowDimensions } from "react-native";
import { ThemeProvider } from "@emotion/react";
import { darkTheme, lightTheme } from "../../utils/theme";
import { useStorage } from "../../utils/storage";
import { noop } from "lodash";

const STORED_THEME = "theme/storedTheme";
const DEFAULT_SCREEN_HEIGHT = 896;

const ThemeContext = createContext({
	theme: darkTheme,
	updateTheme: noop,
});

export const AppContextProvider = (props) => {
	const [theme, setStoredTheme] = useStorage(STORED_THEME);
	const { height } = useWindowDimensions();
	const verticalScale =
		height >= DEFAULT_SCREEN_HEIGHT ? 1 : height / DEFAULT_SCREEN_HEIGHT;

	const defaultTheme = { ...darkTheme, verticalScale };

	// ensure stored theme is up to date
	const restoreTheme =
		theme?.name === "light"
			? { verticalScale, ...lightTheme }
			: { verticalScale, ...darkTheme };

	const updateTheme = (newTheme) => {
		let theme = { ...newTheme, verticalScale };
		setStoredTheme(theme);
	};

	return (
		<ThemeContext.Provider value={{ theme: restoreTheme, updateTheme }}>
			<ThemeProvider theme={restoreTheme || defaultTheme}>
				{props.children}
			</ThemeProvider>
		</ThemeContext.Provider>
	);
};

export const AppConsumer = ThemeContext.Consumer;
export const AppContext = ThemeContext;
